import SuccessIcon from 'components/Icons/SuccessIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ProcessedMobile = () => {
  const { t } = useTranslation(['history', 'beneficiaries']);

  return (
    <div className="success-import-mobile">
      <p>{t('details')}</p>
      <SuccessIcon />
      <span>{t('successful_import')}</span>
    </div>
  );
};
